import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetch } from "../../Util/axios_helper";

const initialState = {
  functionTypes: [],
  functionTypesLoaded: false,
  functionTypesEvent: [],
  functionTypesEventLoaded: false,
  selFunctionTypes: [],
  selFunEvent: [],
  selGoalType: [],
  selMonthWeek: [],
  selEvent: [],
  selEveType: [],
  selAttendees: [],
  selAttendeesWhatIn: [],
  Futures: "",
  Ballroom: [],
  selBalroom: [],
  culturalList: [],
  culturalListLoaded: false,
  functionList: [],
  functionListLoaded: false,
  goalList: [],
  goalListLoaded: false,
  whatsincludeList: [],
  whatsincludeListLoaded: false,
  ballroomList: [],
  ballroomListLoaded: false,
  goalTypeDropList: [],
  goalTypeDropListLoaded: false,
  monthWeekDropList: [],
  monthWeekDropListLoaded: false,
  noAttendeesList: [],
  noAttendeesListLoaded: false,
  ballRoomMapList: [],
  ballRoomMapLoaded: false,
  eventType: [],
  eventTypeLoaded: false,
  showPriorityBallroom: true,
  showAttendess: true,
  showEvent: true,
};
//Culture
export const getFunctionTypes = createAsyncThunk(
  "getFunctionTypes",
  async (TypeId) => {
    return await fetch("Configuration/GetFunctionTypeList?TypeId=${TypeId}");
  }
);
export const getFunctionTypesEvent = createAsyncThunk(
  "getFunctionTypesEvent",
  async () => {
    return await fetch("Configuration/GetEventandFunTypes?id=0");
  }
);
export const getCulturalList = createAsyncThunk("getCulturalList", async () => {
  return await fetch("Configuration/CultureList");
});

//Event
export const getEventTypes = createAsyncThunk("getEventTypes", async () => {
  return await fetch("Configuration/GetEventTypesForBallroomImages");
});
//Function
export const getFunctionList = createAsyncThunk("getFunctionList", async () => {
  return await fetch("Configuration/FunctionTypeList");
});

//Whats Include
export const getWhatsincludeList = createAsyncThunk(
  "getWhatsincludeList",
  async () => {
    return await fetch("Configuration/WhatsIncludeList");
  }
);
export const getBallRoomList = createAsyncThunk("getBallRoomList", async () => {
  return await fetch("Configuration/GetBallroomListForDrop");
});
export const getGoalTypesDropList = createAsyncThunk(
  "getGoalTypesDropList",
  async () => {
    return await fetch("Configuration/GoalTypesListDrop");
  }
);
export const getMonthWeekDropList = createAsyncThunk(
  "getMonthWeekDropList",
  async () => {
    return await fetch("Configuration/MonthWeekListDrop");
  }
);
export const getNoofAttendeesList = createAsyncThunk(
  "getNoofAttendeesList",
  async () => {
    return await fetch("Configuration/GetNoofAttendeesList");
  }
);
export const getballRoomMapList = createAsyncThunk(
  "getballRoomMapList",
  async () => {
    return await fetch("Configuration/BallroomMapList");
  }
);

//goal
export const getGoalList = createAsyncThunk("getGoalList", async () => {
  return await fetch("Configuration/GoalList");
});

const configurationSlice = createSlice({
  name: "getFunctionTypes",
  initialState: initialState,
  reducers: {
    onCulturalEdit: (state, action) => {
      try {
        let data = action.payload;
        if (data) {
          let selFunctionTypesIds = data.FunctionTypeIds
            ? data.FunctionTypeIds.split(",")
            : [];
          state.selFunctionTypes = selFunctionTypesIds;
        } else {
          state.selFunctionTypes = [];
        }
      } catch (e) {
        console.error(e);
      }
    },
    onFunctionEdit: (state, action) => {
      try {
        let data = action.payload;
        if (data) {
          let selEventTypeId = data.EventTypeId
            ? data.EventTypeId.split(",")
            : [];
          state.selEveType = selEventTypeId;
        } else {
          state.selEveType = [];
        }
      } catch (e) {
        console.error(e);
      }
    },
    onGoalEdit: (state, action) => {
      try {
        let data = action.payload;
        if (data) {
          let selGoalTypeId = data.GoalTypeId;
          state.selGoalType = selGoalTypeId;
          let selMonthWeekId = data.MonthWeekId;
          state.selMonthWeek = selMonthWeekId;
        } else {
          state.selGoalType = [];
          state.selMonthWeek = [];
        }
      } catch (e) {
        console.error(e);
      }
    },
    onBalMapEdit: (state, action) => {
      try {
        let data = action.payload;
        if (data) {
          let selAttendeesId = data.BallRoomAttendesIds
            ? data.BallRoomAttendesIds.split(",")
            : [];
          state.selAttendees = selAttendeesId;
          let selFunEventId = data.BallRoomEventIds
            ? data.BallRoomEventIds.split(",")
            : [];

          state.selFunEvent = selFunEventId;
        } else {
          state.selFunEvent = [];
          state.selAttendees = [];
        }
      } catch (e) {
        console.error(e);
      }
    },

    onBallroomImgModalOpen: (state) => {
      state.ballroomImgLog = state.ballroomImgLog + 1;
    },
    onPriorityEditClick: (state, data) => {
      state.showPriorityBallroom = data.payload;
    },
    onhandleEditClick: (state, data) => {
      state.showAttendess = data.payload;
      state.showEvent = data.payload;
    },
  },
  extraReducers: (builder) => {
    //function types
    builder.addCase(getFunctionTypes.pending, (state) => {
      state.functionTypesLoaded = false;
    });

    builder.addCase(getFunctionTypes.fulfilled, (state, data) => {
      state.functionTypes = data.payload;
      state.functionTypesLoaded = true;
    });

    builder.addCase(getFunctionTypes.rejected, (state) => {
      state.functionTypes = [];
      state.functionTypesLoaded = true;
    });
    //event and fun
    builder.addCase(getFunctionTypesEvent.pending, (state) => {
      state.functionTypesEventLoaded = false;
    });

    builder.addCase(getFunctionTypesEvent.fulfilled, (state, data) => {
      state.functionTypesEvent = data.payload;
      state.functionTypesEventLoaded = true;
    });

    builder.addCase(getFunctionTypesEvent.rejected, (state) => {
      state.functionTypesEvent = [];
      state.functionTypesEventLoaded = true;
    });
    //cluster Event
    builder.addCase(getEventTypes.pending, (state) => {
      state.eventTypeLoaded = false;
    });

    builder.addCase(getEventTypes.fulfilled, (state, data) => {
      state.eventType = data.payload;
      state.eventTypeLoaded = true;
    });

    builder.addCase(getEventTypes.rejected, (state) => {
      state.eventType = [];
      state.eventTypeLoaded = true;
    });
    //cultural list
    builder.addCase(getCulturalList.pending, (state) => {
      state.culturalListLoaded = false;
    });

    builder.addCase(getCulturalList.fulfilled, (state, data) => {
      state.culturalList = data.payload;
      state.culturalListLoaded = true;
    });

    builder.addCase(getCulturalList.rejected, (state) => {
      state.culturalList = [];
      state.culturalListLoaded = true;
    });
    //function
    builder.addCase(getFunctionList.pending, (state) => {
      state.functionListLoaded = false;
    });

    builder.addCase(getFunctionList.fulfilled, (state, data) => {
      state.functionList = data.payload;
      state.functionListLoaded = true;
    });

    builder.addCase(getFunctionList.rejected, (state) => {
      state.functionList = [];
      state.functionListLoaded = true;
    });

    //ballroomlist
    builder.addCase(getBallRoomList.pending, (state) => {
      state.ballroomListLoaded = false;
    });

    builder.addCase(getBallRoomList.fulfilled, (state, data) => {
      state.ballroomList = data.payload;
      state.ballroomListLoaded = true;
    });

    builder.addCase(getBallRoomList.rejected, (state) => {
      state.ballroomList = [];
      state.ballroomListLoaded = true;
    });
    //monthweekdrop
    builder.addCase(getMonthWeekDropList.pending, (state) => {
      state.monthWeekDropListLoaded = false;
    });

    builder.addCase(getMonthWeekDropList.fulfilled, (state, data) => {
      state.monthWeekDropList = data.payload;
      state.monthWeekDropListLoaded = true;
    });

    builder.addCase(getMonthWeekDropList.rejected, (state) => {
      state.monthWeekDropList = [];
      state.monthWeekDropListLoaded = true;
    });

    //goaltypedrop
    builder.addCase(getGoalTypesDropList.pending, (state) => {
      state.goalTypeDropListLoaded = false;
    });

    builder.addCase(getGoalTypesDropList.fulfilled, (state, data) => {
      state.goalTypeDropList = data.payload;
      state.goalTypeDropListLoaded = true;
    });

    builder.addCase(getGoalTypesDropList.rejected, (state) => {
      state.goalTypeDropList = [];
      state.goalTypeDropListLoaded = true;
    });
    //NoAttendees
    builder.addCase(getNoofAttendeesList.pending, (state) => {
      state.noAttendeesListLoaded = false;
    });

    builder.addCase(getNoofAttendeesList.fulfilled, (state, data) => {
      state.noAttendeesList = data.payload;
      state.noAttendeesListLoaded = true;
    });

    builder.addCase(getNoofAttendeesList.rejected, (state) => {
      state.noAttendeesList = [];
      state.noAttendeesListLoaded = true;
    });
    //What Include List
    builder.addCase(getWhatsincludeList.pending, (state) => {
      state.whatsincludeListLoaded = false;
    });

    builder.addCase(getWhatsincludeList.fulfilled, (state, data) => {
      state.whatsincludeList = data.payload;
      state.whatsincludeListLoaded = true;
    });

    builder.addCase(getWhatsincludeList.rejected, (state) => {
      state.whatsincludeList = [];
      state.whatsincludeListLoaded = true;
    });
    //ballroommap list
    builder.addCase(getballRoomMapList.pending, (state) => {
      state.ballRoomMapLoaded = false;
    });

    builder.addCase(getballRoomMapList.fulfilled, (state, data) => {
      let ballroomMapLst = data.payload;
      if (ballroomMapLst) {
        ballroomMapLst.sort(function (a, b) {
          let eventComparision = a.BallRoomEventIds.localeCompare(
            b.BallRoomEventIds
          );
          if (eventComparision !== 0) {
            return eventComparision;
          }

          let attendeesComparision = a.BallRoomAttendesIds.localeCompare(
            b.BallRoomAttendesIds
          );
          if (attendeesComparision !== 0) {
            return attendeesComparision;
          }
          return eventComparision;
        });
        state.ballRoomMapList = ballroomMapLst;
      }
      state.ballRoomMapLoaded = true;
    });

    builder.addCase(getballRoomMapList.rejected, (state) => {
      state.ballRoomMapList = [];
      state.ballRoomMapLoaded = true;
    });
    //goal
    builder.addCase(getGoalList.pending, (state) => {
      state.goalListLoaded = false;
    });

    builder.addCase(getGoalList.fulfilled, (state, data) => {
      state.goalList = data.payload;
      state.goalListLoaded = true;
    });

    builder.addCase(getGoalList.rejected, (state) => {
      state.goalList = [];
      state.goalListLoaded = true;
    });
  },
});

export const {
  onCulturalEdit,
  onGoalEdit,
  onBalMapEdit,
  onFunctionEdit,
  onPriorityEditClick,
  onhandleEditClick,
  onBallroomImgModalOpen,
} = configurationSlice.actions;

export default configurationSlice.reducer;
